import { Link, useRouter } from "@tanstack/react-router";
import { type ReactNode } from "react";
import { Button } from "./ui/button";
import { Card } from "./ui/card";

interface AuthRequiredProps {
    icon?: ReactNode;
    title?: string;
    description?: string;
    className?: string;
}

export function AuthRequired({
    icon,
    title = "Sign In Required",
    description = "Please sign in to access this content.",
    className = "p-8 max-w-md",
}: AuthRequiredProps) {
    const router = useRouter();
    const currentPath = router.state.location.pathname;

    return (
        <div className="flex items-center justify-center min-h-96">
            <Card className={className}>
                <div className="text-center space-y-4">
                    {icon}
                    <h2 className="text-2xl font-bold">{title}</h2>
                    <p className="text-muted-foreground">{description}</p>
                    <Button asChild>
                        <Link to="/sign-in" search={{ redirectTo: currentPath }}>
                            Sign In
                        </Link>
                    </Button>
                </div>
            </Card>
        </div>
    );
}
